import { useState } from "react";
import { validateUserName } from "./validateUserName";

export interface NameField {
  value: string;
  // Ошибка показывается только после blur или попытки отправки.
  error: string | null;
  isValid: boolean;
  isChanged: boolean;
  onChange: (value: string) => void;
  touch: () => void;
}

export const useNameField = (
  initial: string | null,
  onEdit: () => void,
): NameField => {
  const [value, setValue] = useState(initial ?? "");
  const [touched, setTouched] = useState(false);
  const validationError = validateUserName(value);

  return {
    value,
    error: touched ? validationError : null,
    isValid: validationError === null,
    isChanged: value.trim() !== (initial ?? ""),
    onChange: (next) => {
      setValue(next);
      onEdit();
    },
    touch: () => setTouched(true),
  };
};
